"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    transform: "translate(-37 1)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(143.5 86.2)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(-99.5 -76.2)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M21.549,17.06H4.567a4.576,4.576,0,0,1-3.425-1.234A4.57,4.57,0,0,1,0,12.48V4.528C0,1.614,1.627,0,4.567,0H21.549c2.94.013,4.567,1.614,4.567,4.541v7.953a4.607,4.607,0,0,1-1.142,3.333,4.638,4.638,0,0,1-3.425,1.234M4.567,1.5A3.175,3.175,0,0,0,2.2,2.257a3.122,3.122,0,0,0-.722,2.283v7.953c0,2.1.984,3.071,3.084,3.071H21.549c2.1,0,3.084-.984,3.084-3.071V4.541a3.159,3.159,0,0,0-.722-2.283A3.21,3.21,0,0,0,21.549,1.5Z",
          transform: "translate(0 0)",
          fill: "#fff"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M76.17,142.5H69.648a.748.748,0,0,1,0-1.5H76.17a.748.748,0,0,1,.748.748.761.761,0,0,1-.748.748",
          transform: "translate(-59.858 -122.496)",
          fill: "#fff"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M-6.415.14a2.975,2.975,0,0,1-2.15-.66,2.079,2.079,0,0,1-.5-.805,3.7,3.7,0,0,1-.16-1.185V-6.84h1.55v4.33a2.6,2.6,0,0,0,.075.675,1,1,0,0,0,.255.455,1.339,1.339,0,0,0,1,.33,1.329,1.329,0,0,0,.99-.32A1,1,0,0,0-5.1-1.82a2.591,2.591,0,0,0,.075-.68V-6.84h1.38v4.26a4.094,4.094,0,0,1-.155,1.2,1.909,1.909,0,0,1-.515.845,2.338,2.338,0,0,1-.89.5A3.872,3.872,0,0,1-6.415.14Zm3.69-6.98h1.56v2.79h2.41V-6.84h1.56V0H1.245V-2.88h-2.41V0h-1.56Zm6.51,0H5.9a6.549,6.549,0,0,1,1.655.175,2.338,2.338,0,0,1,1.075.595,3.539,3.539,0,0,1,.83,2.62,5.351,5.351,0,0,1-.2,1.585,2.744,2.744,0,0,1-.625,1.1,2.31,2.31,0,0,1-.995.58A5.236,5.236,0,0,1,6.105,0H3.785Zm2.22,5.7a1.642,1.642,0,0,0,1.47-.61,1.929,1.929,0,0,0,.28-.68,5.163,5.163,0,0,0,.08-1.02,4.433,4.433,0,0,0-.11-1.12,1.607,1.607,0,0,0-.37-.68,1.3,1.3,0,0,0-.59-.345,3.449,3.449,0,0,0-.94-.105h-.48v4.56Z",
      transform: "translate(57 22)",
      fill: "#fff"
    })]
  })
});

var UHD = function UHD(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '7 8 26.1 26.1';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "UHD-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = UHD;
exports["default"] = _default;

//# sourceMappingURL=index.js.map